import actions from '../../actionTypes';

export default group => {
  return {
    type: actions.EDIT_GROUP,
    group
  };
};



// WEBPACK FOOTER //
// ./src/reducers/groups/actions/editGroup.js